/**
 * Decodes HTML entities to their corresponding characters
 * @param {string} text - Text with HTML entities
 * @returns {string} Decoded text
 */
const decodeHtmlEntities = (text) => {
  if (typeof document === 'undefined') {
    // Server-side: use manual replacement for common entities
    return text
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")
      .replace(/&nbsp;/g, ' ')
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
      .replace(/&#x([0-9a-f]+);/gi, (match, hex) => String.fromCharCode(parseInt(hex, 16)))
  }
  // Client-side: use DOM API for comprehensive decoding
  const textarea = document.createElement('textarea')
  textarea.innerHTML = text
  return textarea.value
}

const bodyTrim = (data, wordsCount) => {
  if (!data) {
    return ""
  }
  // Remove HTML tags
  const body = data.replace(/(<([^>]+)>)/gi, "")
  // Decode HTML entities
  const decodedBody = decodeHtmlEntities(body)
  const bodyArray = decodedBody.split(" ")
  const bodyTrimmed = bodyArray.slice(0, wordsCount).join(" ")
  // add ... if the body is longer than the wordsCount
  if (bodyArray.length > wordsCount) {
    return `${bodyTrimmed}...`
  }
  return bodyTrimmed
}

export default bodyTrim
